export const GET_NEXT_PAYOUT = "GET_NEXT_PAYOUT";
export const GET_PAYMENTS_TRANSACTION = "GET_PAYMENTS_TRANSACTION";
export const GET_PAYMENTS_TOTAL = "GET_PAYMENTS_TOTAL";
export const GET_PAYMENTS_DATE = "GET_PAYMENTS_DATE";
export const RESET_PAYMENTS_STATE = "RESET_PAYMENTS_STATE";
